import { Component, computed, inject, input, signal, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, ControlContainer, FormGroup } from '@angular/forms';
import { ThousandSeparatorDirective } from '../../../../../admin-customer-shared-components/create-pharmacy-component/pharmacy-quota/utils/separator.directive';
import { DropdownArrow } from '../../../../../../shared/ui/icons/dropdown-arrow/dropdown-arrow';
import { LookupVTO } from '../../../../../../pages/admin-dashboard/admin-companies/admin-companies.model';

interface Zone {
  id: number;
  titleEn: string;
  titleAr: string;
}

@Component({
  selector: 'app-product-prices',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ThousandSeparatorDirective, DropdownArrow],
  templateUrl: './product-prices.html',
  styleUrl: './product-prices.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
})
export class ProductPrices {
  private container = inject(ControlContainer);
  private locale = inject(LOCALE_ID);
  type = input<'create' | 'edit'>();
  showZone = input<boolean>(true);
  zones = input<LookupVTO[]>([]);
  isArabic = computed(() => this.locale.startsWith('ar'));

  get form(): FormGroup {
    return this.container.control as FormGroup;
  }

  err(field: string, errorKey: string): boolean {
    const ctrl = this.form.get(field);
    return !!(ctrl?.hasError(errorKey) && (ctrl?.touched || this.form.touched));
  }

  invalid(field: string): boolean {
    const ctrl = this.form.get(field);
    return !!(ctrl?.invalid && (ctrl?.touched || this.form.touched));
  }
}
